import { render } from "./index3.vue?vue&type=template&id=d85f4a48&scoped=true"
import script from "./index3.vue?vue&type=script&lang=js"
export * from "./index3.vue?vue&type=script&lang=js"

import "./index3.vue?vue&type=style&index=0&id=d85f4a48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d85f4a48"]])

export default __exports__